export const QueryParamKeys = {
    Search: "search",
    SortOrder: "sortOrder",
    SortField: "sortField",
    Page: "page",
    PageSize: "pageSize",
    ColumnOrder: "columnOrder",
    Filter: "filter"
};
